<template>
  <div ref="naverMap" id="naverMap"/>
</template>

<script>
    export default {
        name: "naver-map" ,
        props : ['sfLocation'],
        created () {

        },
        mounted () {
          //console.log(this.$store.state.informationStore.information.location);
          const {address , buildingName , buildingUrl , positionX , positionY , siteUrl} = this.$store.getters[('informationStore/getInformationLocation')];
          const { companyName , typeOfProduct } = this.$store.getters[('informationStore/getInformationAbout')]

          const mapDiv = this.$refs.naverMap;
          const sunnyFactory = {
            positionX : positionX,
            positionY : positionY,
            address : address,
            siteUrl : siteUrl,
          };

          var mapInfoString = [
            '<div id="iw_inner">',
            '<h3 class="companyName">&nbsp;'+companyName+'</h3>',
            '<p class="address">'+address+'<br></p>',
            // '<p class="typeOfProduct">&nbsp;'+typeOfProduct+'</p>',
            '<img class="_logo" src="https://avatars1.githubusercontent.com/u/20347395?s=400&v=4" width="55" height="55" alt="서울시청" class="thumb" /><br>',
            '&nbsp;&nbsp;<a href="http://factorysunny.com" target="_blank">'+siteUrl+'</a>',
            '</div>'
          ].join('');

          const mapOptions = {
            center: new naver.maps.LatLng(positionX, positionY),
            zoom: 13 ,
            scrollWheel : true,
          };

          const map = new naver.maps.Map(mapDiv , mapOptions);
          const marker = new naver.maps.Marker({
            position: new naver.maps.LatLng(positionX, positionY),
            map: map
          });
          const infowindow = new naver.maps.InfoWindow({
            maxWidth: 250,
            content: mapInfoString
          });

          naver.maps.Event.addListener(marker, "click", function(e) {
            if (infowindow.getMap()) {
              infowindow.close();
            } else {
              infowindow.open(map, marker);
            }
          });

          infowindow.open(map, marker);
        },
    }
</script>

<style lang="scss">
  @import '@/styles/Global.scss';

  #iw_inner{
    >h3.companyName{
      @include respond-to('medium') {
        font-size:1rem;
      }
    }
    >p.address {
      font-weight: 100;
      @include respond-to('medium') {
        font-size:0.85rem;
      }
    }
    >p.typeOfProduct {
      font-size:0.8rem;
      font-weight:100;
      text-align: center;
    }
    >img._logo{
      float:right;
      padding-right:5px;
      padding-bottom:5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/NaverMap.vue